import React from 'react';
import { CheckIcon } from 'lucide-react';
import { solutionPoints } from '../data/content';
export function Solution() {
  return <section className="w-full bg-white py-14 md:py-20" data-id="element-171" data-mp="1ek2p7swds9x4">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-172" data-mp="10tpi1srbcz8u">
        <h2 className="mx-auto max-w-4xl text-center text-3xl font-extrabold leading-tight tracking-tight text-slate-900 md:text-5xl" data-id="element-173" data-mp="10r39pqwlmfpk">
          Todo lo que necesitas consultar, organizado en 50 Mapas Visuales
        </h2>

        <ul className="mx-auto mt-10 grid max-w-4xl gap-x-10 gap-y-5 md:grid-cols-2" data-id="element-174" data-mp="vu31b9ca10va">
          {solutionPoints.map(point => {
          const [lead, ...rest] = point.split(':');
          return <li key={point} className="flex items-start gap-3" data-id="element-175" data-mp="mt51l38vffii">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-teal-900 text-white" data-id="element-176" data-mp="mvitx4c62dmd">
                  <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-177" data-mp="2h75vd9pkdcbq" />
                </span>
                <span className="text-slate-900" data-id="element-178" data-mp="70qolnnu4oek">
                  <strong className="font-bold" data-id="element-179" data-mp="6z7ao3pnipfy">{lead}:</strong>
                  <span className="text-slate-600" data-id="element-180" data-mp="2zorbcdhamf8">{rest.join(':')}</span>
                </span>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}